import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import classNames from 'classnames'
import { ResponsiveButtonProps } from './ResponsiveButton.types'
import css from './ResponsiveButton.styles.scss'

const ResponsiveButton: React.FC<ResponsiveButtonProps> = ({
  children,
  ...props
}) => (
  <div className={css.ResponsiveButton__Container}>
    <Button
      className={classNames(
        css.ResponsiveButton,
        css.ResponsiveButton__HiddenMobile
      )}
      size="lg"
      {...props}
    >
      {children}
    </Button>
    <Button
      className={classNames(
        css.ResponsiveButton,
        css.ResponsiveButton__MobileOnly
      )}
      size="md"
      {...props}
    >
      {children}
    </Button>
  </div>
)

export default ResponsiveButton
